export function isActivityInteractionLocked({ lock, activityId, type, dayKey }) {
  if (!lock) return false;
  if (lock.kind === 'workout-reorder') return String(activityId) !== String(lock.activityId);
  if (lock.kind === 'food-move') return type !== 'meal' || dayKey !== lock.dayKey;
  return false;
}
